import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class Footer {
  constructor({ el }) {
    this.$el = $(el);
    this._validate();
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    this.instagramToken = $('.footer-instagram', this.$el).data('instagram-access-token');
    this.twitterId = $('.footer-tweet', this.$el).data('twitter-id');
    this.twitterRetweets = $('.footer-tweet', this.$el).data('twitter-retweets');

    if ($('.footer-instagram', this.$el).length && this.instagramToken.length) {
      this.count = $('.footer-instagram', this.$el).data('instagram-count') * 1;
      this.fetchInstagramPhotos();
    }

    if ($('.twitter-enabled', this.$el).length) {
      this.fetchTweets(this.twitterId, this.twitterRetweets);
    }
  }

  fetchInstagramPhotos() {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${this.instagramToken}&count=${this.count}&callback=?`;

    $.ajax(url, {
      type: 'GET',
      dataType: 'jsonp',
      timeout: 10000,
      error: (jqXHR, textStatus) => {
        $('.footer-instagram', this.$el).hide();
        console.log(`Instagram Error: ${textStatus}`);

        if (textStatus === 'timeout') {
          console.log('A timeout error means that either the API is down or the merchant provided an incorrect User ID causing a 404.');
        }
      },

      success: (query) => {
        let i;
        if (this.count === 3) { i = 2; } else { i = 5; }

        if (query.meta.code === 200) {
          (() => {
            query.data.slice(0, +i + 1 || undefined).forEach((photo) => {
              const image = photo.images.standard_resolution;
              const scale = image.width > image.height ? 'y' : 'x';

              $('.footer-instagram-photos')
                .append(`\
<div class="footer-instagram-photo">
        <a
            class="instagram-link"
            href="${photo.link}"
            target="_blank"
        >
            <img
                class="
                    instagram-image
                    instagram-image-scale-${scale}
                "
                src="${image.url}"
            />
        </a>
</div>\
`);
            });
          })();
        }
        $('.footer-instagram', this.$el).hide();
        console.log(`Instagram Error: ${query.meta.error_message}`);
      },
    });
  }

  fetchTweets() {
    const config = {
      profile: { screenName: this.twitterId },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: this.twitterRetweets,
      customCallback: this.renderTweets,
      showInteraction: false,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    if (tweets.length) {
      $('.footer-tweet', this.$el).append(`<span class='tweet-wrap'>${tweets[0]}</span>`);
    } else {
      console.log('No tweets to display. Most probably cause is an incorrectly entered Widget ID.');
    }
  }
}
